import React, { useState } from "react";
import { Button, CircularProgress, Input } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import "./EditAttachment.css";
import axiosApiInstance from '../axios';
import CAlertBox from '../CAlertBox/CAlertBox';

const EditAttachment = ({ onfChange, info, setIsTicketStatusChanged }) => {
  const [files, setFiles] = useState([]);
  const [showName, setShowName] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const fetchedToken = localStorage.getItem("token");

  const OnAddMore = (e) => {
    const allAttach = Array.from(e.target.files).map((file) => file);
    setFiles((prevAtt) => prevAtt.concat(allAttach));
    const fileArray = Array.from(e.target.files).map((file) => file.name);
    setShowName((prevNames) => prevNames.concat(fileArray));
  };

  const rmvAttach = (e) => {
    let x = e.target.getAttribute("delattach");
    setFiles(files.filter((v) => v.name !== x));
    setShowName(showName.filter((art) => art !== x));
  };

  const updateFile = (e) => {
    if(files.length === 0){
      setAlertMessage(`Please upload a valid file.`);
    }else{
      setLoading(true);
      e.preventDefault();
      
      let bodyFormData = new FormData();
      bodyFormData.append("TicketId", info);
    
      // File validation function
      const isValidFile = (file) => {
        const allowedFileTypes = [
          "jpg", "png", "zip", "txt", 
          "doc", "docx", "jpeg", 
          "xlsx", "xls", "pdf"
        ];
        const fileType = file.name.split('.').pop().toLowerCase(); // Extract file extension
        const maxSize = 5 * 1024 * 1024; // 5MB
    
        if (!allowedFileTypes.includes(fileType)) {
          setAlertMessage(`Invalid file type: ${file.name}. Allowed types are: ${allowedFileTypes.join(", ")}`);
          return false;
        }
        if (file.size === 0) {
          setAlertMessage(`File ${file.name} is empty. Please upload a valid file.`);
          return false;
        }
        if (file.size > maxSize) {
          setAlertMessage(`File ${file.name} exceeds the maximum size of 5MB.`);
          return false;
        }
        return true;
      };
    
      // Validate and append files to FormData
      for (let j = 0; j < files.length; j++) {
        let finalFiles = files[j];
        if (isValidFile(finalFiles)) {
          bodyFormData.append("formFiles", finalFiles);
        } else {
          setLoading(false); // Stop loading if a file is invalid
          return; // Exit if any file is invalid
        }
    }
  
    // Send the request
    axiosApiInstance.post('/File/AddTicketAttachmentById', bodyFormData)
      .then((res) => {
        setLoading(false); // Stop loading before handling response
        if (res.data.succeeded === true) {
          setIsTicketStatusChanged(true);
          onfChange();
        }
        if (res.data.succeeded === false) {
          setAlertMessage("There was an error. Please try again.");
        }
      })
      .catch((err) => {
        setLoading(false); // Stop loading on error
        setAlertMessage(err.message || "An unexpected error occurred.");
      });
    }
  };

  
  return (
    <>
      <div className="add-attach-file">
        <label>
          <Button className="addfile" variant="contained" component="span">
            Add Files
          </Button>
          <Input
            className="edit-input"
            id="contained-button-file"
            onChange={OnAddMore}
            multiple
            type="file"
          />
        </label>
      </div>
      {showName.length > 0
        ? showName.map((shw, id) => (
            <div className="showAttachFile" key={id}>
              {shw}

              <DeleteOutlineOutlinedIcon
                className="delAttachFile"
                delattach={shw}
                onClick={rmvAttach}
              />
            </div>
          ))
        : " "}

      <div className="all-btn">
        <Button
          className="editFile-save-btn"
          variant="contained"
          onClick={updateFile}
        >
          {loading ? <CircularProgress className="file-progress" /> : "Save"}
        </Button>
        <Button className="editFile-cancel-btn" onClick={onfChange}>
          Cancel
        </Button>
      </div>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />
    </>
  );
};

export default EditAttachment;
